import type {
  ICompanyDocument,
  ICompanyUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createCompanyDocument,
  updateDocument: updateCompanyDocument,
  deleteDocument: deleteCompanyDocument,
} = makeDocumentService<ICompanyDocument, ICompanyUploadDocument>(
  '/api/companydocuments',
  'companyDocument'
)
